module.exports = __webpack_public_path__ + "static/img/car-words.c8e9afbc.png";